import { getExecEndpoint } from '../../service/getExecEndpoint';
import { defaultServer } from '~/api/def/servers/defaultServer';
import { BqResponse, ResponseSuccessBase } from '~/api/def/endpoints/types';

export const jurisdictionEndpoint = {
  server: defaultServer,
  path: 'jurisdiction',
  description:
    'Jurisdiction CRUD operations no delete for now, also funds by jurisdiction',
};

const endpointJurisdictionExec =
  getExecEndpoint<jurisdictionEndpointDef>(jurisdictionEndpoint);

/** GET JURISDICTION LIST
 * */
export const endpointJurisdictionsGET = async () =>
  endpointJurisdictionExec<'GET'>({ method: 'GET' });

/** CREATE JURISDICTION
 * */
export const endpointJurisdictionPOST = async (
  payload: JurisdictionsPostPayload,
) => endpointJurisdictionExec<'POST'>({ method: 'POST', payload: payload });

/** UPDATE JURISDICTION
 * */
export const endpointJurisdictionPATCH = async (
  id: string,
  payload: JurisdictionsPostPayload,
) =>
  endpointJurisdictionExec<'PATCH'>({
    method: 'PATCH',
    payload: payload,
    urlExtra: `/${id}`,
  });

/** GET JURISDICTION FUNDS
 * */
export const endpointJurisdictionFundsGET = async (id: string) =>
  endpointJurisdictionExec<'GET'>({
    method: 'GET',
    urlExtra: `/${id}/fund`,
  });

export interface jurisdictionEndpointDef {
  endpoint: typeof jurisdictionEndpoint;
  methods: {
    GET: {
      response: ResponseSuccessBase & { data: JurisdictionsGetData[] };
    };
    POST: {
      response: JurisdictionsPostResponse;
      payload: JurisdictionsPostPayload;
    };
    PATCH: {
      response: JurisdictionsPostResponse;
      payload: JurisdictionsPostPayload;
    };
  };
}
export interface jurisdictionFundsEndpointDef {
  endpoint: typeof jurisdictionEndpoint;
  methods: {
    GET: {
      response: FundJurisdictionResponse;
    };
  };
}

export type JurisdictionsGetData = {
  id: string;
  name: string;
  abbreviation: string;
};
export type JurisdictionsPostPayload = {
  name: string;
  abbreviation: string;
};

export type JurisdictionsPostResponse = BqResponse<{ data: { id: string } }>;

export type FundJurisdictionFullData = {
  id: string;
  name: string;
  inceptionDate: string;
  terminationDate: string;
  size: number;
  currency: string;
  jurisdiction: JurisdictionsGetData;
};

export type FundJurisdictionResponse = BqResponse<{
  data: FundJurisdictionFullData[];
}>;
